import { render } from "./VistaPreviaMedicamento.vue?vue&type=template&id=0da831a0"
import script from "./VistaPreviaMedicamento.vue?vue&type=script&lang=js"
export * from "./VistaPreviaMedicamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__